<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<!-- <em class="lt_text">Received Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="fromDate"/> ~ <CustomDatePicker v-model="toDate"/></span> -->
				<span class="int_type_no_border mgr_10" style="padding-top:3px;">
					<label class="mgr_10"><input type="radio" value="P" v-model="search_type" v-on:change="search()" /> On Purchase Order</label>
					<label class="mgr_10"><input type="radio" value="S" v-model="search_type" v-on:change="search()" /> Shipped</label>
					<label class="mgr_10"><input type="radio" value="R" v-model="search_type" v-on:change="search()" /> Received</label>
				</span>

				<span class="int_type_no_border mgr_5">
					<PartnerSelect v-model="vendorCode" ph="Vendor Code" :showName="false" :vendorOnly="true" @set-partner="setPartner" />
				</span>
			</div>
			<div class="left_option">
				<item-class-select-multi-s ref="ItemClassSelectMultiS" :multiSelect="true" v-model="itemClasses" />
			</div>
			<div class="left_option">
				<span class="mgr_10">
					<em class="lt_text">Item </em>
					<span class="int_type sm_int">
						<input type="text" v-model.trim="item_keyword" placeholder="Enter Search Keyword" autofocus autocomplete="off" @keyup.enter="search()" />
					</span>
				</span>

				<span class="mgr_10">
					<em class="lt_text">PO/Ship </em>
					<span class="int_type sm_int">
						<input type="text" v-model.trim="ps_keyword" placeholder="Enter Search Keyword" autofocus autocomplete="off" @keyup.enter="search()" />
					</span>
				</span>

				<a href="javascript:void(0);" class="search_bt" @click="search()">Search</a>
				<a href="javascript:void(0);" class="gray_bt" @click="reset()">Reset</a>
				<span style="display:inline-block;padding-top:5px;padding-left:10px;"> Max 5,000 Records</span>
			</div>
		</div>
		<div>
			<div class="fixed-table-container">
				<div class="table-wrapper" style="height: 95%">
					<table class="list_tbl sticky_list_tbl" v-columns-resizable id="excelTable">
						<!-- <colgroup>
							<col style="width: 7%" />
							<col style="width: 7%" />
							<col style="width: 7%" />
							<col style="width: 15%" />
							<col />
							<col style="width: 5%" />
							<col style="width: 7%" />
							<col style="width: 7%" />
							<col style="width: 7%" />
							<col />
						</colgroup> -->

						<thead>
							<tr>
								<th style="width: 5%">Vendor Code</th>
								<th style="width: 8%">Vendor Name</th>
								<th style="width: 5%">PO No</th>
								<th style="width: 5%">PO Date</th>
								<th style="width: 12%">Item Code</th>
								<th style="width: 20%">Item Name</th>
								<th style="width: 5%">Order Qty</th>
								<th style="width: 5%">Unit Price</th>
								<th style="width: 5%">Order Amt</th>
								<th>Shipment No(s)</th>
								<th style="width: 5%">Shipped Qty</th>
								<th style="width: 5%">Shipped Amt</th>
								<th style="width: 5%">Rcvd Qty</th>
								<th style="width: 5%">Rcvd Amt</th>
								<!-- <th>SH NO</th>
								<th>Vendor Code</th>
								<th>Vendor Name</th>
								<th>Item</th>
								<th>Color</th>
								<th>Qty</th>
								<th>Price</th>
								<th>Amount</th> -->
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in items" v-bind:key="index">
								<td class="al_left">{{ item.vendor_code }}</td>
								<td class="al_left truncate">{{ item.vendor_name }}</td>
								<td class="al_left">{{ item.po_dn }}</td>
								<td class="al_left">{{ item.po_date }}</td>
								<td class="al_left">{{ item.item_code }}</td>
								<td class="al_left truncate">{{ item.item_name }}</td>
								<td class="al_right">{{ item.order_quantity | commaSeparated }}</td>
								<td class="al_right">{{ item.order_price | toCurrency }}</td>
								<td class="al_right">{{ item.order_amount | toCurrency }}</td>
								<td class="al_left">{{ item.shipment_nos }}</td>
								<td class="al_right">{{ item.shipped_quantity | commaSeparated }}</td>
								<td class="al_right">{{ item.shipped_amount | toCurrency }}</td>
								<td class="al_right">{{ item.received_quantity | commaSeparated }}</td>
								<td class="al_right">{{ item.received_amount | toCurrency }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div style="text-align:right;padding-right:10px;padding-top:5px;">Total Count : {{ list_count | commaSeparated }}</div>
			</div>
		</div>

		<div class="bottom_bt_box">
			<ul>
				<li>
					<a href="javascript:void(0);" v-on:click="excel">Excel</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
//import { daysAgo, today } from '@/utils/date';
//import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import PartnerSelect from '@/components/common/PartnerSelect';
//import { shipmentPageGo } from '@/api/util';
import { apiSelectOnOrderDetail } from '@/api/purchase/purchase';
import { exportExcel } from '@/api/util';
import ItemClassSelectMultiS from '@/components/common/ItemClassSelectMultiS';

export default {
	data: function() {
		return {
			// fromDate: daysAgo(6),
			// toDate: today(),
			search_type: 'P',
			vendorCode: null,
			itemClasses: [],
			ps_keyword: null,
			item_keyword: null,
			list_count: null,
			// root: {
			// 	value: {
			// 		list: [],
			// 	},
			// },
			items: [],
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
	},
	components: {
		//CustomDatePicker,
		PartnerSelect,
		ItemClassSelectMultiS,
	},
	methods: {
		setPartner(partner) {
			this.vendor_code = partner.code;
			this.search();
		},
		reset() {
			// this.fromDate = daysAgo(6);
			// this.toDate = today();
			this.ps_keyword = null;
			this.item_keyword = null;
			this.vendorCode = null;
			this.$refs.ItemClassSelectMultiS.reset();
		},
		async search() {
			const { data } = await apiSelectOnOrderDetail({
				search_type: this.search_type,
				vendor_code: this.vendorCode,
				item_classes: this.itemClasses,
				ps_keyword: this.ps_keyword,
				item_keyword: this.item_keyword,
			});

			//console.log(data);
			this.items = data.onOrderList;
			this.list_count = this.items.length;
			// const paramObj = {
			// 	from_date: this.fromDate,
			// 	to_date: this.toDate,
			// 	vendor_code: this.vendorCode,
			// 	item_classes: this.itemClasses,
			// };
			// //const param = objectToFormData(paramObj);
			// var { data } = await apiReceivedGoods(paramObj);
			// //console.log(data);
			// if (!this.user.po_price_view) {
			// 	data.value.forEach(l => {
			// 		l.unit_price = null;
			// 		l.received_amount = null;
			// 		l.vendor_code = null;
			// 		l.vendor_name = null;
			// 	});
			// }
			// this.root = data;
		},
		excel() {
			const eid = 'excelTable';
			const fileName = 'OnOrderDetail';
			exportExcel(eid, fileName);
		},
		// shipmentGo(shipmentNo) {
		// 	shipmentPageGo(shipmentNo);
		// },
	},
	created() {
		this.$store.commit('setSideIndex', 2);
		this.$store.commit('setSelectedMenu', 'nav_li_on_order_detail');
		this.$store.commit('setSubTitle', 'Purchase -> On Order Detail');

		if (this.$route.query.class_code) this.itemClasses.push(this.$route.query.class_code);

		this.search();
	},
	mounted() {},
};
</script>

<style></style>
